import React from "react";

export default function MailIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M154-130q-43.725 0-74.862-31.137Q48-192.275 48-236v-488q0-43.725 31.138-74.862Q110.275-830 154-830h652q43.725 0 74.862 31.138Q912-767.725 912-724v488q0 43.725-31.138 74.863Q849.725-130 806-130H154Zm326-287 326-199v-108L480-520 154-724v108l326 199Z"/></svg>
    );
}
